import React, { Component } from "react";

const Success = ({
  onCloseClick,
  color,
  lightColor
}: {
  onCloseClick: () => void;
  color: string;
  lightColor: string;
}) => {
  const colors = {
    "--primary-color": color,
    "--secondary-color": lightColor
  } as React.CSSProperties;
  return (
    <div
      className="Success"
      style={{
        ...colors,
        display: "grid",
        gridTemplateRows: "auto 1fr",
        gridRowGap: "50px"
      }}
    >
      <div>
        <h1>Success!</h1>
        <h3 style={{ marginTop: "20px" }}>
          We will be in touch to see when you’re ready to replenish.
        </h3>
      </div>
      <button
        onClick={onCloseClick}
        className="close"
      >
        Close
      </button>
    </div>
  );
};
export default Success;
